import { Link } from 'react-router-dom';
import * as SC from './style';

const Footer = () => {
  return (
    <SC.Footer>
      <hr />
      <SC.Links>
        <ol>
          <li>
            <Link to="/impressum">Impressum</Link>
          </li>
          <li>
            <Link to="/legal">Rechtline Hinweise</Link>
          </li>
        </ol>
      </SC.Links>
    </SC.Footer>
  );
};

export default Footer;
